import { useDragAndDropContext } from "./DragAndDropContext";

export const useIsSidebarDropZoneAvailable = () => {
  const { availableDropZones } = useDragAndDropContext();
  // If the base availability is false, no need to check additional conditions
  if (!availableDropZones.sidebar) {
    return false;
  }

  return availableDropZones.sidebar;
};
